import { createApi } from '@reduxjs/toolkit/query/react';
import { createBaseQuery } from 'shared/api/rtk-query';

export const regionApi = createApi({
  reducerPath: 'region-api',
  tagTypes: ['Regions'],
  baseQuery: createBaseQuery(),
  endpoints: () => ({}),
});
